import $erc721 from './erc721/index.js';
import $ifilMining from './ifilMining/index.js';
import $ifilMiningV2 from './ifilMiningV2/index.js';
import $ifilMiningV3 from './ifilMiningV3/index.js';
import $ifilMiningV4 from './ifilMiningV4/index.js';
import $ifilMiningV5 from './ifilMiningV5/index.js';
import $ifilNftTrade from './ifilNftTrade/index.js';
import $ifilNftTradeV2 from './ifilNftTradeV2/index.js';
import $ifilVendor from './ifilVendor/index.js';
import $ifilVendorV2 from './ifilVendorV2/index.js';
import $ifilVendorV3 from './ifilVendorV3/index.js';
import $ifilVendorV4 from './ifilVendorV4/index.js';
import $ifilVendorV5 from './ifilVendorV5/index.js';
import $pledgePool from './pledgePool/index.js';

const getVersionByContract = (vendorContractAdddress) => {
    if ($ifilVendor.getIfilVendorAddress() == vendorContractAdddress) {
        return 1;
    } else if ($ifilVendorV2.getIfilVendorAddressV2() == vendorContractAdddress) {
        return 2;
    } else if ($ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress) {
        return 3;
    } else if ($ifilVendorV4.getIfilVendorAddressV4() == vendorContractAdddress) {
        return 4;
    } else if ($ifilVendorV5.getIfilVendorAddressV5() == vendorContractAdddress) {
        return 5;
    }

    return 0;
}

const getErc721AddressByContract = (vendorContractAdddress) => {
    if ($ifilVendor.getIfilVendorAddress() == vendorContractAdddress) {
        return $erc721.getErc721Address("NFT_POWER_V1");
    } else if ($ifilVendorV2.getIfilVendorAddressV2() == vendorContractAdddress ||
        $ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress ||
        $ifilVendorV4.getIfilVendorAddressV4() == vendorContractAdddress) {
        return $erc721.getErc721Address("NFT_POWER_V2");
    } else if ($ifilVendorV5.getIfilVendorAddressV5() == vendorContractAdddress) {
        return $erc721.getErc721Address("NFT_POWER_V5");
    }
    return undefined;
}

const getMiningAddressByContract = (vendorContractAdddress) => {
    if ($ifilVendor.getIfilVendorAddress() == vendorContractAdddress) {
        return $ifilMining.getIfilAddress();
    } else if ($ifilVendorV2.getIfilVendorAddressV2() == vendorContractAdddress) {
        return $ifilMiningV2.getIfilAddressV2();
    } else if ($ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress) {
        return $ifilMiningV3.getIfilAddressV3();
    } else if ($ifilVendorV4.getIfilVendorAddressV4() == vendorContractAdddress) {
        return $ifilMiningV4.getIfilAddressV4();
    } else if ($ifilVendorV5.getIfilVendorAddressV5() == vendorContractAdddress) {
        return $ifilMiningV5.getIfilAddressV5();
    }
    return undefined;
}

const getMiningByContract = (vendorContractAdddress) => {
    if ($ifilVendor.getIfilVendorAddress() == vendorContractAdddress) {
        return $ifilMining.getIfilContract();
    } else if ($ifilVendorV2.getIfilVendorAddressV2() == vendorContractAdddress) {
        return $ifilMiningV2.getIfilContractV2();
    } else if ($ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress) {
        return $ifilMiningV3.getIfilContractV3();
    } else if ($ifilVendorV4.getIfilVendorAddressV4() == vendorContractAdddress) {
        return $ifilMiningV4.getIfilContractV4();
    } else if ($ifilVendorV5.getIfilVendorAddressV5() == vendorContractAdddress) {
        return $ifilMiningV5.getIfilContractV5();
    }
    return undefined;
}

const getNftTradeAddressByContract = (vendorContractAdddress) => {
    if ($ifilVendor.getIfilVendorAddress() == vendorContractAdddress) {
        return $ifilNftTrade.getIfilNftTradeAddress();
    } else if ($ifilVendorV2.getIfilVendorAddressV2() == vendorContractAdddress ||
        $ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress ||
        $ifilVendorV4.getIfilVendorAddressV4() == vendorContractAdddress ||
        $ifilVendorV5.getIfilVendorAddressV5() == vendorContractAdddress) {
        return $ifilNftTradeV2.getIfilNftTradeAddressV2();
    }
    return undefined;
}

const getErc721AddressByVersion = (version) => {
    if (version == 1) {
        return $erc721.getErc721Address("NFT_POWER_V1");
    } else if (version == 2 || version == 3 || version == 4) {
        return $erc721.getErc721Address("NFT_POWER_V2");
    } else if (version == 5) {
        return $erc721.getErc721Address("NFT_POWER_V5");
    }
    return undefined;
}

const getMiningAddressByVersion = (version) => {
    if (version == 1) {
        return $ifilMining.getIfilAddress();
    } else if (version == 2) {
        return $ifilMiningV2.getIfilAddressV2();
    } else if (version == 3) {
        return $ifilMiningV3.getIfilAddressV3();
    } else if (version == 4) {
        return $ifilMiningV4.getIfilAddressV4();
    } else if (version == 5) {
        return $ifilMiningV5.getIfilAddressV5();
    }
    return undefined;
}

const getNftTradeAddressByVersion = (version) => {
    if (version == 1) {
        return $ifilNftTrade.getIfilNftTradeAddress();
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        return $ifilNftTradeV2.getIfilNftTradeAddressV2();
    }
    return undefined;
}

const getNftTradeNameByVersion = (version) => {
    if (version == 1) {
        return $ifilNftTrade.getIfilNftTradeName();
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        return $ifilNftTradeV2.getIfilNftTradeNameV2();
    }
    return undefined;
}

const getNftTradeVersionByVersion = (version) => {
    if (version == 1) {
        return $ifilNftTrade.getIfilNftTradeVersion();
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        return $ifilNftTradeV2.getIfilNftTradeVersionV2();
    }
    return undefined;
}

const getNftTradeSaltByVersion = (version) => {
    if (version == 1) {
        return $ifilNftTrade.getIfilNftTradeSalt();
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        return $ifilNftTradeV2.getIfilNftTradeSaltV2();
    }
    return undefined;
}

const tradeNFTByContract = ([makerData, vendorContractAdddress], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilNftTrade.tradeNFT([makerData], options, callback);
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        let _miner = getErc721AddressByContract(vendorContractAdddress);
        return $ifilNftTradeV2.tradeNFTV3([_miner, makerData], options, callback);
    }
    return undefined
}

const tradeNFTEstimateSendByContract = ([makerData, vendorContractAdddress], options) => {

    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilNftTrade.tradeNFTEstimateSend([makerData], options);
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        let _miner = getErc721AddressByContract(vendorContractAdddress);
        return $ifilNftTradeV2.tradeNFTEstimateSendV3([_miner, makerData], options);
    }
    return undefined
}

const userPledgeByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.userPledge([...params], options, callback);
    }
    return undefined;
}

const userPledgeEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.userPledgeEstimateSend([...params], options);
    }
    return undefined;
}

const getIfilNftTradeContractByContract = (vendorContractAdddress) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilNftTrade.getIfilNftTradeContract();
    } else if (version == 2 || version == 3 || version == 4 || version == 5) {
        return $ifilNftTradeV2.getIfilNftTradeContractV2();
    }
    return undefined;
}

const getErc721IsApprovedForAllByContract = ([owner, operator, vendorContractAdddress], options) => {
    let erc721Address = getErc721AddressByContract(vendorContractAdddress);
    if (!!erc721Address) {
        return $erc721.getErc721IsApprovedForAll([erc721Address, owner, operator], options);
    }
    return undefined;
}

const erc721SetApprovalForAllByContract = ([vendorContractAdddress, operator, _approved], options, callback) => {
    let erc721Address = getErc721AddressByContract(vendorContractAdddress);
    if (!!erc721Address) {
        return $erc721.erc721SetApprovalForAll([erc721Address, operator, _approved], options, callback);
    }
    return undefined;
}

const erc721SetApprovalForAllEstimateSendByContract = ([vendorContractAdddress, operator, _approved], options) => {
    let erc721Address = getErc721AddressByContract(vendorContractAdddress);
    if (!!erc721Address) {
        return $erc721.erc721SetApprovalForAllEstimateSend([erc721Address, operator, _approved], options);
    }
    return undefined;
}

const getErc721ContractByContract = (vendorContractAdddress) => {
    let erc721Address = getErc721AddressByContract(vendorContractAdddress);
    if (!!erc721Address) {
        return $erc721.getErc721Contract(erc721Address);
    }
    return undefined;
}

const createNFTByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilMining.createNFT([...params], options, callback);
    } else if (version == 2) {
        return $ifilMiningV2.createNFTV2([...params], options, callback);
    } else if (version == 3) {
        return $ifilMiningV3.createNFTV3([...params], options, callback);
    } else if (version == 4) {
        return $ifilMiningV4.createNFTV4([...params], options, callback);
    } else if (version == 5) {
        return $ifilMiningV5.createNFTV5([...params], options, callback);
    }
    return undefined;
}

const createNFTEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilMining.createNFTEstimateSend([...params], options, callback);
    } else if (version == 2) {
        return $ifilMiningV2.createNFTEstimateSendV2([...params], options);
    } else if (version == 3) {
        return $ifilMiningV3.createNFTEstimateSendV3([...params], options);
    } else if (version == 4) {
        return $ifilMiningV4.createNFTEstimateSendV4([...params], options);
    } else if (version == 5) {
        return $ifilMiningV5.createNFTEstimateSendV5([...params], options);
    }
    return undefined;
}

const getBuyLimitInfoByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 2) {
        return $ifilMiningV2.getBuyLimitInfoV2([...params], options);
    } else if (version == 3) {
        return $ifilMiningV3.getBuyLimitInfoV3([...params], options);
    } else if (version == 4) {
        return $ifilMiningV4.getBuyLimitInfoV4([...params], options);
    } else if (version == 5) {
        return $ifilMiningV5.getBuyLimitInfoV5([...params], options);
    }
    return undefined;
}

const withdrawBenefitsEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    console.log(version)
    if (version == 1) {
        return $ifilMining.withdrawBenefitsEstimateSend([...params], options);
    } else if (version == 2) {
        return $ifilMiningV2.withdrawBenefitsEstimateSendV2([...params], options);
    } else if (version == 3) {
        return $ifilMiningV3.withdrawBenefitsEstimateSendV3([...params], options);
    } else if (version == 4) {
        return $ifilMiningV4.withdrawBenefitsEstimateSendV4([...params], options);
    } else if (version == 5) {
        return $ifilMiningV5.withdrawBenefitsEstimateSendV5([...params], options);
    }
    return undefined;
}

const withdrawBenefitsByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    console.log(version)
    if (version == 1) {
        return $ifilMining.withdrawBenefits([...params], options);
    } else if (version == 2) {
        return $ifilMiningV2.withdrawBenefitsV2([...params], options, callback);
    } else if (version == 3) {
        return $ifilMiningV3.withdrawBenefitsV3([...params], options, callback);
    } else if (version == 4) {
        return $ifilMiningV4.withdrawBenefitsV4([...params], options, callback);
    } else if (version == 5) {
        return $ifilMiningV5.withdrawBenefitsV5([...params], options, callback);
    }
    return undefined;
}

const getPledgePoolContractAddressByContract = (vendorContractAdddress) => {
    if ($ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress) {
        return $pledgePool.getpledgePoolAddress();
    }
    return undefined;
}

const getPledgePoolContractByContract = (vendorContractAdddress) => {
    if ($ifilVendorV3.getIfilVendorAddressV3() == vendorContractAdddress) {
        return $pledgePool.getpledgePoolContract();
    }
    return undefined;
}

const getPoolPledgeInfo = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.getPledgePoolPledgeInfo([...params], options);
    }
    return undefined;
}

const getUserPledgeInfo = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.getPledgePoolgetUserPledgeInfo([...params], options);
    }
    return undefined;
}

const handlelUserBenefitsInfo = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.handlelPledgePoolUserBenefitsInfo([...params], options);
    }
    return undefined;
}

const pledgePoolUserWithdrawByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.pledgePooluserWithdraw([...params], options, callback);
    }
    return undefined;
}

const pledgePoolUserWithdrawEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.pledgePooluserWithdraweEstimateSend([...params], options);
    }
    return undefined;
}

const pledgePoolUserPledgeFailWithdrawByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.pledgePooluserPledgeFailWithdraw([...params], options, callback);
    }
    return undefined;
}

const pledgePoolUserPledgeFailWithdrawEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.pledgePooluserPledgeFailWithdrawEstimateSend([...params], options);
    }
    return undefined;
}

const pledgePoolUserSettlementWithdrawByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.pledgePooluserSettlementWithdraw([...params], options, callback);
    }
    return undefined;
}

const pledgePoolUserSettlementWithdrawEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 3) {
        return $pledgePool.pledgePooluserSettlementWithdrawEstimateSend([...params], options);
    }
    return undefined;
}

const splitNftByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 2) {
        return $ifilMiningV2.splitNftV2([...params], options, callback);
    } else if (version == 3) {
        return $ifilMiningV3.splitNftV3([...params], options, callback);
    } else if (version == 4) {
        return $ifilMiningV4.splitNftV4([...params], options, callback);
    } else if (version == 5) {
        return $ifilMiningV5.splitNftV5([...params], options, callback);
    }
    return undefined;
}

const splitNftEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 2) {
        return $ifilMiningV2.splitNftEstimateSendV2([...params], options);
    } else if (version == 3) {
        return $ifilMiningV3.splitNftEstimateSendV3([...params], options);
    } else if (version == 4) {
        return $ifilMiningV4.splitNftEstimateSendV4([...params], options);
    } else if (version == 5) {
        return $ifilMiningV5.splitNftEstimateSendV5([...params], options);
    }
    return undefined;
}

const mergeNftByContract = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 2) {
        return $ifilMiningV2.mergeNftV2([...params], options, callback);
    } else if (version == 3) {
        return $ifilMiningV3.mergeNftV3([...params], options, callback);
    } else if (version == 4) {
        return $ifilMiningV4.mergeNftV4([...params], options, callback);
    } else if (version == 5) {
        return $ifilMiningV5.mergeNftV5([...params], options, callback);
    }
    return undefined;
}

const mergeNftEstimateSendByContract = ([vendorContractAdddress, ...params], options) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 2) {
        return $ifilMiningV2.mergeNftEstimateSendV2([...params], options);
    } else if (version == 3) {
        return $ifilMiningV3.mergeNftEstimateSendV3([...params], options);
    } else if (version == 4) {
        return $ifilMiningV4.mergeNftEstimateSendV4([...params], options);
    } else if (version == 5) {
        return $ifilMiningV5.mergeNftEstimateSendV5([...params], options);
    }
    return undefined;
}

const getNftInfoByVersion = ([vendorContractAdddress, ...params], options, callback) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilMining.getNftInfo([...params], options, callback);

    } else if (version == 2) {
        return $ifilMiningV2.getNftInfoV2([...params], options, callback);

    } else if (version == 3) {
        return $ifilMiningV3.getNftInfoV3([...params], options, callback);
    } else if (version == 4) {
        return $ifilMiningV4.getNftInfoV4([...params], options, callback);
    } else if (version == 5) {
        return $ifilMiningV5.getNftInfoV5([...params], options, callback);
    }
    return undefined;
}

const getNftInfoCallByVersion = ([vendorContractAdddress, ...params]) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilMining.getNftInfo([...params]);

    } else if (version == 2) {
        return $ifilMiningV2.getNftInfoV2([...params]);

    } else if (version == 3) {
        return $ifilMiningV3.getNftInfoV3Call([...params]);
    } else if (version == 4) {
        return $ifilMiningV4.getNftInfoV4([...params]);
    } else if (version == 5) {
        return $ifilMiningV5.getNftInfoV5([...params]);
    }
    return undefined;
}


const handlelNftInfoByVersion = ([vendorContractAdddress]) => {
    let version = getVersionByContract(vendorContractAdddress);
    if (version == 1) {
        return $ifilMining.getNftInfo([...params]);

    } else if (version == 2) {
        return $ifilMiningV2.getNftInfoV2([...params]);

    } else if (version == 3) {
        return $ifilMiningV3.handlelNftInfoV3;
    } else if (version == 4) {
        return $ifilMiningV4.getNftInfoV4([...params]);
    } else if (version == 5) {
        return $ifilMiningV5.getNftInfoV5([...params]);
    }
    return undefined;
}



export default {
    // getVersionByContract,//ContractAddress  contractAddress
    // getErc721AddressByContract,//ContractAddress 721 address
    // getMiningAddressByContract,//ContractAddress mining address
    // getNftTradeAddressByContract,//ContractAddress trade address
    // getErc721AddressByVersion,//ContractAddress
    getVersionByContract,
    getErc721AddressByContract,
    getMiningByContract,
    getMiningAddressByContract,
    getNftTradeAddressByContract,
    getErc721AddressByVersion,
    getMiningAddressByVersion,
    getNftTradeAddressByVersion,
    getNftTradeNameByVersion,
    getNftTradeVersionByVersion,
    getNftTradeSaltByVersion,

    tradeNFTByContract,
    tradeNFTEstimateSendByContract,
    getIfilNftTradeContractByContract,
    getErc721IsApprovedForAllByContract,
    erc721SetApprovalForAllByContract,
    erc721SetApprovalForAllEstimateSendByContract,
    getErc721ContractByContract,
    getPledgePoolContractByContract,
    getPledgePoolContractAddressByContract,
    userPledgeByContract,
    userPledgeEstimateSendByContract,
    getPoolPledgeInfo,
    getUserPledgeInfo,
    handlelUserBenefitsInfo,
    pledgePoolUserWithdrawByContract,
    pledgePoolUserWithdrawEstimateSendByContract,
    createNFTByContract,
    createNFTEstimateSendByContract,
    getBuyLimitInfoByContract,
    withdrawBenefitsEstimateSendByContract,
    withdrawBenefitsByContract,
    pledgePoolUserPledgeFailWithdrawByContract,
    pledgePoolUserPledgeFailWithdrawEstimateSendByContract,
    pledgePoolUserSettlementWithdrawByContract,
    pledgePoolUserSettlementWithdrawEstimateSendByContract,
    splitNftByContract,
    splitNftEstimateSendByContract,
    mergeNftByContract,
    mergeNftEstimateSendByContract,

    getNftInfoByVersion,
    getNftInfoCallByVersion,
    handlelNftInfoByVersion
}



// WEBPACK FOOTER //
// ./src/lib/contract/power.js